<template>
    <app-layout :main="main">
    <!-- Cta Start -->
    <section class="section bg-cta" style="background: url('/assets/images/course/bg02.jpg') center center;" id="cta">
        <div class="bg-overlay"></div>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 text-center">
                    <div class="section-title">
                        <h4 class="title text-white mb-4">Advance to the next step</h4>
                        <p class="text-white-50 para-desc mx-auto">"{{ main?.settings?.name }}" is a proven revision resource that helps you pass high-stakes medical exams.</p>
                        <a href="#!" data-type="youtube" data-id="yba7hPeTSjk" class="play-btn  mt-4 lightbox">
                            <i data-feather="play" class="fea icon-ex-md text-white"></i>
                        </a>
                    </div>
                </div><!--end col-->
            </div><!--end row-->
        </div><!--end container-->
    </section><!--end section-->
    <!-- Cta End -->

    <!-- Courses Start -->
    <section class="section" id="courses">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 text-center">
                    <div class="section-title mb-4 pb-2">
                        <h4 class="title mb-4">Explore QBanks</h4>
                                                    <p class="para-desc mx-auto text-muted">Explore our wide range of courses designed to help you excel in your studies. Whether you're looking for free resources or comprehensive paid programs, we have something for everyone. Start learning today and achieve your academic goals with our expertly crafted materials.</p>

<!--                        <p class="text-muted para-desc mx-auto mb-0">Start working with <span class="text-primary fw-bold">Landrick</span> that can provide everything you need to generate awareness, drive traffic, connect.</p>-->
                    </div>
                </div><!--end col-->
            </div><!--end row-->

            <div class="row">


                <div class="col-lg-4 col-md-6 col-12 mt-4 pt-2" v-for="course in home?.data?.courses">
                    <course-card :course="course"></course-card>
                </div><!--end col-->

                <div class="col-12 mt-4 pt-2 text-center">
                    <router-link :to="{name: 'courses.index'}" class="btn btn-primary">
                        See More QBanks <i class="uil uil-angle-right-b align-middle"></i>
                    </router-link>

                </div>
            </div><!--end row-->
        </div><!--end container-->

    </section><!--end section-->
    <!-- Courses End -->
    </app-layout>
</template>

<script>
import {useHead} from "@vueuse/head";
import CourseCard from "./course/courseCard.vue";
import AppLayout from "../app-layout.vue";
export default {
    components: {
        AppLayout,
        CourseCard
    },
    name: "home",
    props: ['main'],
    watch: {
        main(newValue) {
            if (newValue !== null) {
                // this.runMainSlider();
            }
        }
    },
    data() {
        return {
            home: [],
        }
    },
    async created() {
        await this.getHome();

        useHead({
            title: this.main?.settings?.name,
        })

    },
    methods: {
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        async getHome() {
            await axios.get('home').then(response => {
                this.home = response.data;
            });
        },
    }
}
</script>

<style scoped>

</style>
